module.exports = __webpack_public_path__ + "static/media/crew.2272341d.svg";